import { HttpMethods, APIContexts } from 'enums';
import { apiRequestHandler, apiHost } from '.';

const apiContext = `${APIContexts.COMMERCIAL}/`;

export const GetCommercialByExternalIdAPI = ({
  externalId,
  onSuccess,
  ...rest
}) => {
  const endpoint = `${apiHost}${apiContext}${externalId}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const DeleteCommercialAPI = ({
  id,
  force = false,
  onSuccess,
  ...rest
}) => {
  const endpoint = `${apiHost}${apiContext}${id}?force=${force}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.DELETE,
    onSuccess: (res) => onSuccess && onSuccess(res),
    ...rest,
  });
};
